<template>
    <div>
        <div class="navbox">
            <div class="navtab">
                <div class="nav">
                    <div class="navleft">
                        <img :src="userImg==null || userImg=='' ||  userImg=='undefined' ? url:$api.url+userImg" alt="" />
                        <div>
                            <div class="name">姓 名： {{userName}}</div>
                            <div class="age">手机号：{{mobile}}</div>
                            <div class="idcard">身份证号：{{userIdcard}}</div>
                        </div>
                    </div>
                    <div class="navright" v-if="bmzt=='1'">
						<div class="course">
						    {{year}}
						    <div>培训年份</div>
						</div>
                        <div class="course">
                            {{parseInt(ggk_zxs * 100)/100}}
                            <div>公需课学时</div>
                        </div>
                        <div class="course">
                            {{parseInt(zyk_zxs * 100)/100}}
                            <div>专业课学时</div>
                        </div>
                        <div class="course">
                          {{parseInt(ggk_zxs * 100 + zyk_zxs * 100) /100}}
                          <div>总学时</div>
                        </div>
                    </div>
					<div class="navright" v-if="bmzt=='0'">
						<div class="course">
						您当前未报名，请先报名后开始学习
						</div>
					</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import {queryClazzUserInfo,queryUserSchoolHours} from '@/api/user.js'

export default {
	name: 'ourNav',
    data() {
        return {
			token:null,
            url: require("../assets/img/index/userLog.jpeg"),
			loginstate:false,
			user:null,
			year:localStorage.getItem('year'),
			userName:localStorage.getItem('user_name'),
			userIdcard:localStorage.getItem('id_card'),
			mobile:localStorage.getItem('user_mobile'),
            userImg:localStorage.getItem('user_img'),
			ggk_zxs:0,
			zyk_zxs:0,
			bmzt:'0'
		};
    },
	mounted() {
		this.queryUserSchoolHours();
	},
	methods:{
		queryUserSchoolHours(){
			var parm = {
				year:localStorage.getItem('year'),
			}
			queryUserSchoolHours(parm).then(res => {
				if(res.code == 200){
					this.bmzt = res.bmzt;
					if(this.bmzt == '1'){
						this.ggk_zxs = res.ggk_zxs;
						this.zyk_zxs = res.zyk_zxs;
					}else{

						this.ggk_zxs = 0.00;
						this.zyk_zxs = 0.00;
					}
					
				}
			})
		},
	}
};
</script>
<style lang="less" scoped>
.navtab {
    width: 1280px;
    margin: 0 auto;
}
// 用户信息
.navbox {
    background: #2961EF;
    .nav {
        padding: 35px 0;
        display: flex;
        justify-content: space-between;
        .navleft {
            display: flex;
            align-items: center;
            img {
                width: 130px;
                height: 130px;
                border-radius: 50%;
                border: 6px solid #ffae74;
                margin-right: 23px;
            }
            .name {
                font-size: 20px;
                color: #ffffff;
            }
            .age {
                font-size: 16px;
                color: rgba(255,255,255,.7);
                margin: 27px 0 7px 0;
            }
            .idcard {
                font-size: 16px;
                color: rgba(255,255,255,.7);
            }
        }
        .navright {
            margin-top: 60px;
            display: flex;
            align-items: center;
            .course {
                font-size: 30px;
                font-weight: 600;
                color: #ffffff;
                text-align: center;
                padding: 0 35px;
                div {
                    text-align: center;
                    font-size: 16px;
                    font-weight: normal;
                    color: #ffffff;
                }
            }
        }
    }
}
</style>
